module.exports = __webpack_public_path__ + "img/drajzerova-logo-first.e3f909d4.png";